var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoutA = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3273 4.7882C12.9961 4.45589 12.4587 4.45583 12.1274 4.78815C11.7961 5.12051 11.796 5.65935 12.1274 5.99172L14.6386 8.51064H4.24253C3.77394 8.51064 3.39404 8.89169 3.39404 9.3617C3.39404 9.83172 3.77394 10.2128 4.24253 10.2128H14.6384L12.1274 12.7315C11.796 13.0638 11.796 13.6027 12.1274 13.935C12.2931 14.1012 12.5102 14.1843 12.7274 14.1843C12.9445 14.1843 13.1617 14.1012 13.3273 13.935L17.2868 9.96352C17.6182 9.63121 17.6182 9.09231 17.2868 8.75995L13.3273 4.7882Z",
    fill: "#434C58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20202 18.7234C8.67061 18.7234 9.0505 18.3423 9.0505 17.8723C9.0505 17.4023 8.67061 17.0213 8.20202 17.0213H1.69697V1.70213H8.20202C8.67061 1.70213 9.0505 1.32108 9.0505 0.851063C9.0505 0.381049 8.67061 0 8.20202 0H0.848485C0.379895 0 0 0.381049 0 0.851063V17.8723C0 18.3423 0.379895 18.7234 0.848485 18.7234H8.20202Z",
    fill: "#434C58"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoutA);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logout-a.69f88fa24f045b029651230e996c4585.svg";